var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5303 0.46967C13.8232 0.762563 13.8232 1.23744 13.5303 1.53033L2.81066 12.25L10 12.25C10.4142 12.25 10.75 12.5858 10.75 13C10.75 13.4142 10.4142 13.75 10 13.75L1 13.75C0.585786 13.75 0.25 13.4142 0.25 13L0.250001 4C0.250001 3.58579 0.585787 3.25 1 3.25C1.41421 3.25 1.75 3.58579 1.75 4L1.75 11.1893L12.4697 0.46967C12.7626 0.176777 13.2374 0.176777 13.5303 0.46967Z",
    fill: "var(--color-blue)",
    stroke: "var(--color-blue)",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDec);
export default __webpack_public_path__ + "static/media/dec.b8b7a871e2848efe012ff2644851aa22.svg";
export { ForwardRef as ReactComponent };